import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type InitialStateType = {
  isAuth: boolean
  user: User | null
}

const initialState: InitialStateType = {
  isAuth: false,
  user: null,
}

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload
      state.isAuth = true
    },
    updateUserInfo: (state, action: PayloadAction<Partial<User>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
      }
    },
    logout: () => initialState,
  },
})

export const profileActions = profileSlice.actions
export const profileReducer = profileSlice.reducer
